import { getLink } from "../../../utils/utils";
const content = (
	`
	<p class="text-center bold mb-3">* * *</p>

	<p class="mb-3">
		Kial Esperanto ne enradikiĝis en la familio de aktualaj lingvoj? 
		Kial eĉ nun, post 130 jaroj da ekzisto, ĝi restas et-eta marĝena lingvo, kaj plejmulto de loĝantaro de la Tero ne konas ĝin?
	</p>
	
	<p class="mb-3">
		Kial eĉ (kaj eble des pli) sciencistoj rilatas al ĝi neserioze, senatente aŭ eĉ malestime?
	</p>
	
	<p class="mb-3">
		Eble, pro tio, ke esperanto estas neviva lingvo?
	</p>
	
	<p class="mb-3">
		Ja homo estas unuavice biologia estaĵo, kaj se oni senigos lin de ebloj spiri, manĝi, pisi – li neeviteble mortos. 
		Sen kontentigo de tiuj, ofte ĝenaj kaj nebelaj bezonoj homo ne povas vivi. 
		Kaj en ajna homa lingvo oni parolas pri tio. 
		Pri amo (en ĝia fizika aspekto), pri beleco de naturo kaj feliĉo kunfandiĝi kun ĝi, percepti ĝian forton, senti sin ĝia ero, estas kreita grandega literaturo en ĉiuj lingvoj. 
		En ĉiuj, krom Esperanto.
	</p>
	
	<p class="mb-3">
		Ĝin posedas homoj inteligentaj, edukitaj, ĉu ne? ili ne estas iuj primitivaj sovaĝuloj, kiuj ĝojas la Sunon aŭ faras heroaĵojn dank’ al sia forto kaj sano.
	</p>
	
	<p class="mb-3">
		Ne, esperantistoj estas homoj seriozaj. 
		Kaj parolas ili pri seriozaj aferoj: lingvaj rajtoj, feliĉigo de la homaro, konsciigo kaj kapabligo… eĉ en poezio predominas sociaj temoj. Idealoj… idealoj forte logas la esperantiston, kaj li emas atingi ilin, ŝvebi pli alten por alproksimiĝi al ili. 
		Kaj ĝuste pro tio, leviĝante, li perdas la kontakton kun la tero kaj fariĝas persono aereca, ideala, neviva. 
		Li ne vivas en la lingvo per normala vivo de normala homo; verŝajne, oni opinias honton, se en tiu trezoro, tiu ideala lingvo kiel Esperanto, speciale kreita por idealaj celoj, oni parolu pri aferoj de karno.
	</p>
	
	<p class="mb-3">
		Sed eble ĝuste pro tio Esperanto sin diferencas de naturaj lingvoj, ĝuste pro tio ĝi estas senviva?
	</p>
	
	<p class="mb-3">
		Ni donu ekzemplon el “laika”, ne “nia sankta” literaturo: tiun de Teodor Drajzer. 
		Li verkis romanojn pri granda financisto Kaupervud, kaj Kaupervud estis prezentita ne kiel plenviva homo, sed kiel ideala imago de financisto; nenion plu en lia vivo kaj vivo de liaj kunuloj rimarkas la aŭtoro. 
		K. amas multajn virinojn; sed tio estas senviva amo, neniun li fekundigas. 
		En normala vivo antaŭ unu kaj duona jarcento tio ne eblis: ja kontraceptivoj tiam ne estis popularaj kaj eĉ ne sufiĉe disvastigitaj. 
		Certe, almenaŭ kelkaj virinoj gravediĝis kaj postulis subtenon, eble ĉantaĝis…
	</p>
	
	<p class="mb-3">
		Sed tiuj tro homaj aferoj ne bezonatas al la aŭtoro: li ja verkas idealan imagon, sed ne vivan homon. 
		Kun la dua edzino K. ankaŭ ne havas infanojn; sed li ne estas sterila, ĉar havis du kun la unua edzino. 
		Kaj la tuta tragedio de la dua edzino okazas pro tio, ke ŝi ne havas infanojn, ne scias, pri kio okupiĝi. 
		Sed pri tio – eĉ ne unu vorto, ŝi devas malaperi el lia vivo, ĉar la aŭtoro preparis por li novan edzinon por montri lian energion kaj emon al pli altaj atingoj en financa kaj monduma sferoj.
	</p>
	
	<p class="mb-3">
		Li havas du infanojn de la unua edzino; sed eĉ unufoje li ne rememoras pri ili, kvankam nature estus, ke homo akumulas riĉaĵojn por siaj idoj. 
		Sed ajnaj homaj, karnaj aferoj estas absolute ne bezonataj por la aŭtoro: li verkas idealan heroon sen ligoj kun karna vivo. 
		Ankaŭ la patrino de lia tria edzino havas du gefilojn, sed zorgas nur pri la filino; la filo, sur kiun ŝi normale apogu siajn esperojn kaj ambiciojn, tute forestas en ŝia vivo.
	</p>
	
	<p class="mb-3">
		Tiaj familiaj vivaj rilatoj ĝenerale tute forestas en la libro, ĉar la aŭtoro neglektas ilin, ili ne bezonatas al li por lia celo: krei portreton de genia financisto.
	</p>
	
	<p class="mb-3">
		Sed kia estas la rezulto de tiu intenco? Ĉu ni ricevis la libron, kiu genie priskribas la karieron de biznesulo? 
		Ne, ni ricevis tute sentalentan libron, kie kartona heroo agas, sed elvokas nenian intereson, ĉar li estas remburita pupo, senviva ideo aŭ idealo. 
		Kaj kio sekvas? – ke ni malestimas la aŭtoron, kiu ne scipovas krei verajn homojn, sed produktas manekenojn, kiuj agas ne laŭ siaj trajtoj kaj karakteroj, sed simple por klarigi la ideojn de l’ aŭtoro. 
		Kion signifas tio? – Ke la aŭtoro estas sentalenta, kaj ne indus al li strebi eniri en literaturon.
	</p>
	
	<p class="mb-3">
		Do, absolute same okazas pri Esperanto: kun sia strebo al alta idearo ĝi forgesas pri tute homaj sentoj kaj rilatoj, kaj pro tio ĝin ne akceptas la ĉirkaŭa mondo. 
		Homoj sentas, ke en ĝi estas io frida (frigida).
	</p>
	
	<p class="mb-3">
		Estus bone, se nia lingvo iam konvertiĝus en normalan homan lingvon, en kiu oni parolas ne nur pri lingva diskriminacio, sed ankaŭ pri feliĉo kuŝi sur verda herbejo sub hela suno kaj enspiri freŝan aeron…
	</p>
	
	<p class="mb-3">
		Freŝa aero mankas.
	</p>
	`
)

const itemName = {
	esp: 'Freŝa aero mankas'
}
const item = {
	itemlink: getLink(itemName.esp),
	esp: {
		itemName: itemName.esp,
		itemContent: content,
		itemDate: '28 dec. 2016'
	}
}
export default item;